import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContatosService} from '../../../services/contatos.service';
import {moeda} from '../crm-segmentos';

/** Resultados dos últimos 30 dias: quem voltou, quanto as mensagens trouxeram, recompra e tempo até o 2º pedido. */
@Component({
  selector: 'app-metricas-carteira-crm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './metricas-carteira-crm.component.html',
  styleUrls: ['./metricas-carteira-crm.component.scss']
})
export class MetricasCarteiraCrmComponent implements OnInit {
  /** Abrir a Fila de quem está esfriando. */
  @Output() chamar = new EventEmitter<void>();
  metricas: any = null;
  carregando = true;
  moeda = moeda;

  constructor(private contatosService: ContatosService) {}

  ngOnInit(): void {
    this.contatosService.obtenhaMetricasCrm().then((metricas: any) => {
      this.metricas = metricas;
      this.carregando = false;
    }).catch(() => {
      this.carregando = false;
    });
  }

  numero(valor: number): string {
    return (Number(valor) || 0).toLocaleString('pt-BR');
  }

  plural(qtde: number, um: string, varios: string): string {
    return (Number(qtde) === 1 ? um : varios);
  }
}
